import * as AuthSlice from '@frontend/redux/slices/authSlice';
import { useDispatch } from 'react-redux';
import type { BaseRootState } from './helpers';
import { useSelector } from './useSelector';

export const useAuthSlice = <TRootState extends Pick<BaseRootState, 'auth'>>() => {
  const dispatch = useDispatch();

  const { client, token } = useSelector<TRootState>()(({ auth }) => auth);

  const storeToken = (authToken: Parameters<(typeof AuthSlice)['storeToken']>[0]) =>
    dispatch(AuthSlice.storeToken(authToken));

  const clearAuth = () => dispatch(AuthSlice.clearAuth());

  const storeClient = (client: Parameters<(typeof AuthSlice)['storeClient']>[0]) =>
    dispatch(AuthSlice.storeClient(client));

  const clearClient = () => dispatch(AuthSlice.clearClient());

  return { clearAuth, clearClient, client, storeClient, storeToken, token };
};
